const DEFAULT_XTREMEPUSH_TIMEOUT = 5000;

/**
 * Wait for XtremePush SDK to be available
 * @param timeout - Maximum time to wait in milliseconds (default: 5000ms)
 * @param interval - Polling interval in milliseconds (default: 100ms)
 * @returns Promise that resolves when XtremePush is ready.
 */
export function waitForXtremePush(timeout = DEFAULT_XTREMEPUSH_TIMEOUT, interval = 100): Promise<void> {
    return new Promise((resolve, reject) => {
        const startTime = Date.now();

        const check = () => {
            if (window.xtremepush && typeof window.xtremepush === 'function') {
                resolve();
                return;
            }

            if (Date.now() - startTime > timeout) {
                reject(new Error(`XtremePush SDK did not become available within ${timeout}ms.`));
                return;
            }

            setTimeout(check, interval);
        };
        
        check();
    });
}

/**
 * Set user ID in XtremePush with automatic waiting
 * @param userId - The user ID to set
 * @param timeout - Maximum time to wait for XtremePush (default: 5000ms)
 * @returns Promise that resolves when user ID is set or rejects on error
 */
export async function setXtremePushUserId(userId: string | number, timeout = DEFAULT_XTREMEPUSH_TIMEOUT): Promise<void> {
    await waitForXtremePush(timeout);
    window.xtremepush!('set', 'user_id', `${userId}`);
}
